export const fruits = [
  "Almonds",
  "Apple",
  "Apricot",
  "Artichoke",
  "Avocado",
  "Banana",
  "Bean",
  "Beet",
  "Broccoli",
  "Cabbage",
  "Carrot",
  "Celery",
  "Cherries",
  "Coconut",
  "Corn",
  "Cucumber",
  "Currants",
  "Dates",
  "Eggplant",
  "Figs",
  "Fruit",
  "Garlic",
  "Gourd",
  "Grapes",
  "Green",
  "Guava",
  "Kiwi",
  "Leek",
  "Lemon",
  "Lettuce",
  "Lime",
  "Lychee",
  "Mandarin",
  "Mango",
  "Melon",
  "Mushroom",
  "Olives",
  "Onion",
  "Onions",
  "Orange",
  "Papaya",
  "Passion",
  "Peach",
  "Pear",
  "Peas",
  "Pepper",
  "Pineapple",
  "Plantain",
  "Plum",
  "Potato",
  "Prickly",
  "Pumpkin",
  "Raisins",
  "Red",
  "Snow",
  "Spinach",
  "Spring",
  "Sprouts",
  "Strawberry",
  "Tamarillo",
  "Tomato",
  "Turnip",
  "Watermelon",
  "Yam"
];
